import React, { useState } from 'react';
import './FAQ.css';
import Footer from "../../Components/Footer/Footer";

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqs = [
    {
      question: "¿Con cuánto tiempo reservo mi sesión?",
      answer: "Reservar tu sesión con tiempo, te asegura que vamos a lograr una producción prolija y eficaz. Con un mínimo de 1 año ya puedes comenzar a guardar tu lugar para no quedar afuera de la lista de eventos."
    },
    {
      question: "¿Por qué es importante hacerlo con tiempo?",
      answer: "Reservar con anticipación, nos dará la posibilidad de tener una reunión para conocernos, plasmar ideas, pensar lugares, vestuarios y todas las opciones que podes incluir en tu sesión."
    },
    {
      question: "¿Siempre va sole?",
      answer: "En la mayoría de los casos, las producciones están en mano de Sole, pero puede llegar a surgir un imprevisto y el equipo especializado esta preparado y dispuesto para cumplir con las expectativas de cada cliente."
    },
    {
      question: "¿Con cuánto tiempo tengo que hacer mi sesión pre?",
      answer: "Si el resultado de tu producción, esta pensada para tarjetería, lo ideal es hacerlo tres o cuatro meses antes. Ya que desde el día de la primera reunión, comenzamos a planear y en la búsqueda de los elementos que vamos a utilizar. En caso de estar pensado para mostrar el día del evento, con un mínimo de un mes estamos ¡perfectos! "
    },
    {
      question: "¿Tengo formas de pago?",
      answer: "Podes reservar abonando una seña del 50 % y el saldo hasta 7 días antes del evento. con efectivo, transferencia, dólar billete o compras con tarjetas de crédito (este ultimo consultar previamente)"
    },
    {
      question: "¿Pre 15. Sola o con amigas?",
      answer: "¡Como vos lo prefieras! Lo ideal es que vos te sientas cómoda y puedas mostrarte con soltura. No te olvides que sos la protagonista y siempre te vamos a lucir"
    },
    {
      question: "¿Book infantil. Participan los padres?",
      answer: "¡Claro que si! Los padres son los pilares y un recuerdo junto a sus hijos es algo que no puede faltar."
    },
    {
      question: "¿Cuál es el tiempo de entrega del trabajo final?",
      answer: "Debido al flujo de trabajo y que las edición es bastante detallada, el tiempo estimado es de un aproximado de 60 días posteriores al evento. Sin embargo, siempre intentamos acortar los tiempos y que puedas disfrutar de tus fotos lo antes posible."
    },
    {
      question: "¿Debo pagar en dólar billete?",
      answer: "No necesariamente se abona con dólar billete, puede ser pesos a precio del dólar blue."
    },
    {
      question: "¿Tengo que contratar el equipo completo?",
      answer: "Si bien somos un equipo, el cliente puede contratar servicios aislados. El beneficio en Sole Costilla Group es que el cliente encuentre todo en un solo lugar, un equipo que ya se conoce y trabajan en conjunto para lograr un gran evento."
    },
    {
      question: "¿Se entrega material sin editar?",
      answer: "¡Claro que no! Los mejores resultados, están en los detalles de edición, un trabajo sin edición no es un trabajo terminado."
    },
  ];

  return (
    <>
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <div className="intro-line">Preguntas frecuentes</div>
          <h2 className="faq-title">
            Resuelve tus <span className="essence-highlight">dudas</span>
          </h2>
          <p className="faq-description">
            Encuentra respuestas a las preguntas más comunes sobre mis servicios. 
            Si no encuentras lo que buscas, no dudes en contactarme directamente.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openItems[index] ? 'open' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleItem(index)}
                aria-expanded={openItems[index]}
              >
                <span className="question-text">{faq.question}</span>
                <span className="faq-icon">
                  <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path 
                      d="M12 8v8m4-4H8" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              <div className="faq-answer">
                <div className="answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Elementos decorativos flotantes */}
      <div className="faq-floating-elements">
        <div className="floating-element faq-element-1"></div>
        <div className="floating-element faq-element-2"></div>
        <div className="floating-element faq-element-3"></div>
      </div>
    </section>
      <Footer />
    </>
  );
};

export default FAQ;